import { render, staticRenderFns } from "./EffectiveDocList.vue?vue&type=template&id=d2a52d04&scoped=true&"
import script from "./EffectiveDocList.vue?vue&type=script&lang=js&"
export * from "./EffectiveDocList.vue?vue&type=script&lang=js&"
import style0 from "./EffectiveDocList.vue?vue&type=style&index=0&id=d2a52d04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a52d04",
  null
  
)

export default component.exports